import { render, staticRenderFns } from "./Picklist.vue?vue&type=template&id=8408f6b4&scoped=true"
import script from "./Picklist.vue?vue&type=script&lang=js"
export * from "./Picklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8408f6b4",
  null
  
)

export default component.exports